<script>
  export default {
    name: 'poi-tag',
    props: {
      text: String,
      closable: Boolean,
      type: String,
      hit: Boolean,
      disableTransitions: Boolean,
      color: String,
      size: String
    },
    methods: {
      handleClose(event) {
        event.stopPropagation();
        this.$emit('close', event);
      }
    },
    computed: {
      tagSize() {
        return this.size || (this.$ELEMENT || {}).size;
      }
    },
    render(h) {
      const classes = [ 'poi-tag', this.type ? `poi-tag--${this.type}` : '',
        this.tagSize ? `poi-tag--${this.tagSize}` : '',
        {'is-hit': this.hit}
      ];
      const tagEl = (<span class={classes} style={{backgroundColor: this.color}}>
        { this.$slots.default }
        {
          this.closable && <i class="iconfont poi-tag__close poi-icon-close2" style="font-size:12px" on-click={this.handleClose}></i>
        }
      </span>);

      return this.disableTransitions ? tagEl : <transition name="poi-zoom-in-center">{ tagEl }</transition>;
    }
  };
</script>
